import { apiClient } from './client';
import type { WordPressSummary } from '../types';

export const wordpressApi = {
  async getSummary(): Promise<WordPressSummary> {
    const { data } = await apiClient.get<WordPressSummary>('/wordpress/summary');
    return data;
  },
};
